// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"0a1ddb847e5ee3a583bd","655":"8970f53b0b703e1768a3"}[chunkId] + ".js";
};